<svg xmlns="http://www.w3.org/2000/svg" width="101" height="101" viewBox="0 0 101 101">
  <defs>
    <filter id="fxoty444ua">
      <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
    </filter>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <g>
      <g>
        <g>
          <path d="M0 0H100.5V100.5H0z" transform="translate(-590 -259) translate(590 259)"/>
          <g fill="#000" fill-opacity=".35" stroke="#FFF" stroke-width="3" transform="translate(-590 -259) translate(590 259) translate(3.865 3.865)">
            <circle cx="47.046" cy="47.046" r="45.546"/>
          </g>
        </g>
        <g filter="url(#fxoty444ua)" transform="translate(-590 -259) translate(590 259)">
          <g>
            <path d="M0 0H47V47H0z" transform="translate(33 27)"/>
            <path fill="#A09EA3" d="M11.534 43.303c-1.364.98-3.172 1.078-4.636.254-1.463-.824-2.315-2.422-2.185-4.096V6.219c-.13-1.675.722-3.272 2.185-4.097 1.464-.824 3.272-.725 4.636.254l27.587 16.708c1.442.738 2.349 2.222 2.349 3.842s-.907 3.104-2.349 3.842L11.534 43.303z" transform="translate(33 27)"/>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
